import urlBase64ToUint8Array  from './urlBase64ToUint8Array.js';
import moment from 'moment';
const PUBLIC_VAPID_KEY = "BHr526LshW3fCPOfvfvbZ3IGBsKtFumBSQEKkSBB6ZIZVO2QWhxFxUeaySntn8Kl2QD-lP2NLnbJUUi87_7g0zg";
var swRegistration;
global.app['notificationPromt'] = null;

// Service Worker  
if ('serviceWorker' in navigator && !window.location.hostname.includes('localhost')){
  navigator.serviceWorker.register("/notificationWorker.js", {scope: "/"}).then((sw) =>{
    swRegistration = sw;
  });
}

const getSubscription = async () => {
  try{
      // Set the initial subscription value
      let subsExist = await swRegistration.pushManager.getSubscription();
      webPushNotificationsStatus();
      if (subsExist !== null) {
        //await saveSubscriptionOnServer(subsExist);
        console.log('old subscription ==>', subsExist);
        return {"subscription":subsExist};
      } else {
        const newSubscription = await swRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
        });
        deleteSubscriptionOnServer();
        let res = await saveSubscriptionOnServer(newSubscription);
        window.localStorage.setItem('__ksrms-userNotificationSubscriptionId',res.create[0].id);
        console.log('new subscription ==>', res);
        return {"subscription": newSubscription, 'user_notification_subscription_id': res.create[0].id };
      }
    
  }catch(err){
    console.error('ks-APP: NotificationSubscription => ', err);
  }
};


const saveSubscriptionOnServer = async (subscription = null) => {
  // Save Notification in DB
  try{
    if(app.auth.user.lts == 1){
      let aux = JSON.parse(JSON.stringify(subscription));
      if(subscription && typeof subscription === 'object'){
        let res = await app.sdk['rms'][`app_user_device_notification_subscription_create`](
          app.auth.token,
          {
            "campaign_id": 0,
            "key_auth": aux.keys.auth,
            "notification_subscription": JSON.stringify(subscription),
            "create_datetime": moment().format("YYYY-MM-DD HH:mm:ss")
          }
        );
        return res;
      }else{
        throw "Invalid Subscription"
      }
    }else{
      throw "You Should select this is your device"
    }
  }catch(err){
    console.error('ks-APP: NotificationSubscription => ', err);
    throw err;
  }
}

const deleteSubscriptionOnServer = async () => {
  try{
    let subscriptionId = window.localStorage.getItem('__ksrms-userNotificationSubscriptionId');
    if(subscriptionId){
      await app.sdk['rms'][`app_user_device_notification_subscription_delete`](
        app.auth.token,
        { "app_user_device_notification_subscription_id": parseInt(subscriptionId)}
      );
    }
  }catch(err){
    console.error('ks-APP: NotificationSubscription => ', err);
  }
}

const webPushNotificationsStatus = () => {
    // Support
    if(!app.auth.user.lts == 1) throw "Invalid User Device"
    if ('serviceWorker' in navigator && 'PushManager' in window && "Notification" in window) {
      if (Notification.permission === 'granted') {
        //Mean, the notification is accepted.
        console.log('Notification accepted...');
      } else {
        // show a prompt to the user
        global.app['notificationPromt'] = Notification;
        console.log('Prompt to accept notification');
        Notification.requestPermission();
      }
      return Notification.permission;
  } else {
      throw 'Push messaging is not supported';
  }
}

export default { getSubscription, saveSubscriptionOnServer, webPushNotificationsStatus }